<template>
  <div class="item-bloc-form grid grid-cols-3 mb-5">
    <h2>Ajouter UN MOYEN D'EXPEDITION</h2>
    <br>
  </div>
  <div v-if="isLoading" class=" flex justify-content-center">
    <ProgressSpinner style="width: 50px; height: 50px" strokeWidth="8" fill="var(--surface-ground)" 
                     animationDuration=".5s" aria-label="Custom ProgressSpinner" />
  </div>
  <FormKit
        type="form"
        id="add-supplier"
        :form-class="submitted ? 'hide' : 'show'"
        submit-label="Enregistrer"
        @submit="submitHandler"
        :actions="true"
        incomplete-message="Désolé, tous les champs ne sont pas remplis correctement."
        #default="{ value }"
      >
        <FormKit
          type="select"
          label="Transporteur"
          name="transportor"
          validation="required"
          validation-visibility="dirty"
          :validation-messages="{required: 'Il faut choisir un transporteur dans la liste déroulante.',}"
        >
          <option v-for="item in transportors" :key="item.value" :value="item.value">
            {{item.label}}
          </option>
        </FormKit>
        <FormKit
          type="text"
          name="name"
          label="Nom du moyen d’expédition"
          validation="required|length:1,50|contains_alpha"
          validation-visibility="dirty"
          :validation-messages="{required: 'Nom du moyen d’expédition obligatoire.',
           length: 'Vous pouvez saisir maximum 50 caractères', contains_alpha: 'Les valeurs numériques seules ne sont pas acceptées'}"
        />
        <FormKit
          type="text"
          name="deliveryTime"
          label="Délai de livraison"
          validation="required|length:1,25"
          validation-visibility="dirty"
          :validation-messages="{required: 'Vous devez entrer un délai de livraison', length: 'Vous pouvez saisir maximum 25 caractères'}"
        />

        <div class="item-bloc-form grid grid-cols-3 mb-5">
          <h2>Politique particulière*</h2>
        </div>
        <div class="not-valid mb-2">
          <span class="formkit-message text-red-500 text-xs">{{messageErrorParticularPolicyModel}}</span>
        </div>
        <FormKit
          type="checkbox"
          label="Par prix"
          name="shippingRuleByPriceStatus"
          :value="false"
        />
        <div class="not-valid mb-2">
          <span class="formkit-message text-red-500 text-xs">{{messageErrorStartingFromByPrice}}</span>
        </div>
        <FormKit
          id="repeater"
          name="shipping_rules_by_price"
          type="repeater"
          add-label="Ajouter"
          v-if="value.shippingRuleByPriceStatus"
          :up-control="false"
          :down-control="false"
        >
          <div class="item-bloc-form">
            <div class="grid grid-cols-2">
              <div class="pr-2 supplier-item-form">
                <FormKit
                  type="number"
                  label="A partir de "
                  name="startingFrom"
                  validation="required"
                  min="0"
                  step="any"
                  validation-visibility="dirty"
                  :validation-messages="{required: 'Vous devez saisir une valeur',}"
                />
              </div>
              <div class="pr-2 supplier-item-form">
                <FormKit
                  type="number"
                  label="€ frais de port à "
                  name="price"
                  step="any"
                  validation="required"
                  validation-label="frais de port"
                  min="0"
                  validation-visibility="dirty"
                  :validation-messages="{required: 'Vous devez saisir une valeur'}"
                />
              </div>
              <div class="supplier-item-form devise">
                <label class="formkit-label font-bold text-sm">
                  €
                </label>
              </div>
            </div>
          </div>
        </FormKit>

        <FormKit
          type="checkbox"
          label="Par quantité"
          name="shippingRuleByQuantityStatus"
          :value="false"
        />
        <div class="not-valid mb-2">
          <span class="formkit-message text-red-500 text-xs">{{messageErrorStartingFromByQuantity}}</span>
        </div>
        <FormKit
          id="repeater"
          name="shipping_rules_by_quantity"
          type="repeater"
          add-label="Ajouter"
          v-if="value.shippingRuleByQuantityStatus"
          :up-control="false"
          :down-control="false"
        >
          <div class="item-bloc-form">
            <div class="grid grid-cols-2">
              <div class="pr-2 supplier-item-form">
                <FormKit
                  type="number"
                  label="A partir de "
                  name="startingFrom"
                  validation="required"
                  min="1"
                  validation-visibility="dirty"
                  :validation-messages="{required: 'Vous devez saisir une valeur',}"
                />
              </div>
              <div class="pr-2 supplier-item-form">
                <FormKit
                  type="number"
                  label="produit(s) frais de port à "
                  name="price"
                  validation="required"
                  validation-label="frais de port"
                  step="any"
                  min="0"
                  validation-visibility="dirty"
                  :validation-messages="{required: 'Vous devez saisir une valeur',}"
                />
              </div>
              <div class="supplier-item-form devise">
                <label class="formkit-label font-bold text-sm">
                  €
                </label>
              </div>
            </div>
          </div>
        </FormKit>

        <FormKit
          type="checkbox"
          label="Par produit"
          name="shippingRuleByProductStatus"
          :value="false"
        />
        <div class="not-valid mb-2">
          <span class="formkit-message text-red-500 text-xs">{{messageErrorStartingFromByProduct}}</span>
        </div>
        <FormKit
          id="repeater"
          name="shipping_rules_by_product"
          type="repeater"
          add-label="Ajouter"
          v-if="value.shippingRuleByProductStatus"
          :up-control="false"
          :down-control="false"
        >
          <div class="item-bloc-form">
            <div class="grid grid-cols-2">
              <div class="pr-2 supplier-item-form">
                <FormKit
                  type="number"
                  label="A partir de "
                  name="startingFrom"
                  validation="required"
                  min="1"
                  validation-visibility="dirty"
                  :validation-messages="{required: 'Vous devez saisir une valeur',}"
                />
              </div>
              <div class="pr-2 supplier-item-form">
                <FormKit
                  type="number"
                  label="produit(s) frais de port à "
                  name="price"
                  validation="required"
                  validation-label="frais de port"
                  step="any"
                  min="0"
                  validation-visibility="dirty"
                  :validation-messages="{required: 'Vous devez saisir une valeur',}"
                />
              </div>
              <div class="supplier-item-form devise">
                <label class="formkit-label font-bold text-sm">
                  € par produit
                </label>
              </div>
            </div>
          </div>
        </FormKit>
      </FormKit>
</template>
<script setup lang="ts">
import { ref, onMounted } from 'vue'
import ApiService from "@/_services/api.service";
import Swal from "@/_helpers/swal";
import {
  createShippingMethod, getIndexErrorStartingFrom
} from "@/_services/shippingMethod/shippingMethod";
import {useRoute} from "vue-router";
import router from "@/router";
import ProgressSpinner from 'primevue/progressspinner';
const route = useRoute();
const supplierUuid = ref<string>("");
const messageErrorParticularPolicyModel = ref('');
const messageErrorStartingFromByPrice = ref('');
const messageErrorStartingFromByQuantity = ref('');
const messageErrorStartingFromByProduct = ref('');

const transportors = ref([]);
const isLoading = ref<boolean>(true);

onMounted(async () => {
  supplierUuid.value = route.params.uuid as string;
  await getTransportors();
  hideSpinner();
});

const getTransportors = async () => {
  await ApiService.get("all-transporters?isActive=true")
    .then(({ data }) => {
      data.data.forEach((item) => {
        transportors.value.push({ label: item.name, value: item.uuid });
      });
    })
    .catch(() => {
      return false;
    });
};

const showSpinner = () => {
    isLoading.value = true;
}

const hideSpinner = () => {
    isLoading.value = false;
}

const validateShippingRuleStatus = (data) => {
  if (
    data.shippingRuleByPriceStatus ||
    data.shippingRuleByQuantityStatus ||
    data.shippingRuleByProductStatus
  ) {
    return true;
  }
  return false;
};

const checkErrorStartingFrom = (data) => {

  if (data.shipping_rules_by_price) {
    if (parseInt(data.shipping_rules_by_price[0].startingFrom) !== 0) {
      messageErrorStartingFromByPrice.value = "La première règle est obligatoire, elle doit impérativement commencer à 0";
      return true;
    }
  }
  if (data.shipping_rules_by_quantity) {
    if (parseInt(data.shipping_rules_by_quantity[0].startingFrom) !== 1) {
      messageErrorStartingFromByQuantity.value = "La première règle est obligatoire, elle doit impérativement commencer à 1";
      return true;
    }
  }
  if (data.shipping_rules_by_product) {
    if (parseInt(data.shipping_rules_by_product[0].startingFrom) !== 1) {
      messageErrorStartingFromByProduct.value = "La première règle est obligatoire, elle doit impérativement commencer à 1";
      return true;
    }
  }
  return false;
}

const initFormErrorMessage = () => {
  messageErrorStartingFromByPrice.value = '';
  messageErrorStartingFromByQuantity.value = '';
  messageErrorStartingFromByProduct.value = '';
  messageErrorParticularPolicyModel.value = '';
}

const submitHandler = async (data, formNode) => {
    try {
      formNode.clearErrors();
      initFormErrorMessage();
      if (!validateShippingRuleStatus(data)) {
        messageErrorParticularPolicyModel.value = 'Vous devez sélectionner au moins un modèle de politique particulières.'
        return false;
      }

      if (checkErrorStartingFrom(data)) {
        return false;
      }

      if (data.shipping_rules_by_price) {
        let index = getIndexErrorStartingFrom(data.shipping_rules_by_price);
        if (index > 0) {
          const key = `shipping_rules_by_price.${index}.startingFrom`;
          formNode.setErrors(
            null,
            {
              [key]: ['La valeur ne peut pas être inférieur ou égale à la précédente']
            }
          );
          return false;
        }
      }

      if (data.shipping_rules_by_quantity) {
        let index = getIndexErrorStartingFrom(data.shipping_rules_by_quantity);
        if (index > 0) {
          const key = `shipping_rules_by_quantity.${index}.startingFrom`;
          formNode.setErrors(
            null,
            {
              [key]: ['La valeur ne peut pas être inférieur ou égale à la précédente']
            }
          );
          return false;
        }
      }

      if (data.shipping_rules_by_product) {
        let index = getIndexErrorStartingFrom(data.shipping_rules_by_product);
        if (index > 0) {
          const key = `shipping_rules_by_product.${index}.startingFrom`;
          formNode.setErrors(
            null,
            {
              [key]: ['La valeur ne peut pas être inférieur ou égale à la précédente']
            }
          );
          return false;
        }
      }

      data.supplierUuid = supplierUuid.value;
      await Swal
        .confirm("Êtes vous sûr de vouloir créer ce moyen d’expédition", "Annuler", "Oui, créer")
        .then(async (results) => {
            if (results.isConfirmed) {
              const res = await createShippingMethod(data);
              if (res) {
                Swal.info("Vous venez de créer un moyen d’expédition").then(() => {
                  router.push({ name: 'supplierDetail', params: { uuid: supplierUuid.value, ariaSelected: 1 } })
                })
              } else {
                Swal.error("La création du moyen d’expédition a échoué veuillez réessayer.");
              }
            }
          });
    } catch (err: any) {
      Swal.error("Erreur de création de moyen d’expédition");
    }
  }

</script>
<style scoped lang="scss">
.formkit-inner {
  width: max-content;
}
h2{
  text-transform: uppercase;
  padding-bottom: 3px;
  border-bottom: 1px solid #0A3382;
  color : #0A3382;
}
.grid {
  display: inline-flex;
}
.devise {
  margin-top: 10px;
}
.modal-box {
  background-color: #fff;
}

</style>